import { type BatchStatus } from '@reach/shared-types/partner-batches';
import React from 'react';

interface BatchStatusBadgeProps {
  status: BatchStatus;
  className?: string;
}

const statusConfig: Record<BatchStatus, { label: string; className: string }> = {
  processing: {
    label: 'Processing',
    className: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/20 animate-pulse',
  },
  success: {
    label: 'Success',
    className: 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20',
  },
  partial_success: {
    label: 'Partial Success',
    className: 'bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/20',
  },
  failure: {
    label: 'Failed',
    className: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20',
  },
};

export const BatchStatusBadge: React.FC<BatchStatusBadgeProps> = ({ status, className = '' }) => {
  const config = statusConfig[status];

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${config.className} ${className}`}>
      {config.label}
    </span>
  );
};
